/**
 * Mini Cart Module
 *
 * API Pública:
 * - theme.openMiniCart()
 * - theme.closeMiniCart()
 * - theme.reloadMiniCart()
 * - theme.updateCartBadge()
 */

(function() {
  'use strict';

  const miniCart = document.getElementById('miniCart');
  const miniCartOverlay = document.getElementById('miniCartOverlay');
  const miniCartClose = document.getElementById('miniCartClose');
  const miniCartItems = document.getElementById('miniCartItems');
  const miniCartSubtotal = document.getElementById('miniCartSubtotal');
  const miniCartShippingToggle = document.getElementById('miniCartShippingToggle');
  const miniCartShippingPopup = document.getElementById('miniCartShippingPopup');

  if (!miniCart) return;

  let isUpdating = false;

  function openMiniCart() {
    if (window.__calculandoFrete) return;
    reloadMiniCart();
    miniCart.classList.add('active');
    miniCartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMiniCart() {
    miniCart.classList.remove('active');
    miniCartOverlay.classList.remove('active');
    document.body.style.overflow = '';
    if (miniCartShippingPopup) {
      miniCartShippingPopup.classList.remove('active');
      miniCartShippingToggle.classList.remove('active');
    }
  }

  function reloadMiniCart() {
    if (isUpdating) return;
    isUpdating = true;
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderMiniCart(cart);
        updateCartBadge(cart.item_count);
        isUpdating = false;
      })
      .catch(error => {
        console.error('Erro ao carregar carrinho:', error);
        isUpdating = false;
      });
  }

  function renderMiniCart(cart) {
    if (!miniCartItems) return;

    if (cart.item_count === 0) {
      miniCartItems.innerHTML = `
        <div class="mini-cart__empty">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          <p class="mini-cart__empty-text">Seu carrinho está vazio</p>
          <a href="/collections/all" class="mini-cart__empty-button button button--primary">
            Continuar comprando
          </a>
        </div>
      `;
      const footer = miniCart.querySelector('.mini-cart__footer');
      const progressBar = miniCart.querySelector('.mini-cart__progress-bar');
      if (footer) footer.style.display = 'none';
      if (progressBar) progressBar.style.display = 'none';
      return;
    }

    const progressBar = miniCart.querySelector('.mini-cart__progress-bar');
    if (progressBar) progressBar.style.display = 'block';

    let footer = miniCart.querySelector('.mini-cart__footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'mini-cart__footer';
      footer.innerHTML = `
        <div class="mini-cart__shipping-calc">
          <button class="mini-cart__shipping-toggle" id="miniCartShippingToggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="1" y="3" width="15" height="13"></rect>
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
              <circle cx="5.5" cy="18.5" r="2.5"></circle>
              <circle cx="18.5" cy="18.5" r="2.5"></circle>
            </svg>
            <span>Calcular Frete</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="mini-cart__shipping-icon" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
            </svg>
          </button>
          <div class="mini-cart__shipping-popup" id="miniCartShippingPopup"></div>
        </div>
        <div class="mini-cart__subtotal">
          <span class="mini-cart__subtotal-label">Subtotal</span>
          <span class="mini-cart__subtotal-value" id="miniCartSubtotal">${formatMoney(cart.total_price)}</span>
        </div>
        <button class="mini-cart__checkout button button--primary" onclick="window.location.href='/checkout'">
          Finalizar compra
        </button>
        <button class="mini-cart__view-cart" onclick="window.theme.closeMiniCart()">
          Continue comprando
        </button>
      `;
      miniCart.appendChild(footer);

      const newToggle = footer.querySelector('#miniCartShippingToggle');
      const newPopup = footer.querySelector('#miniCartShippingPopup');
      if (newToggle && newPopup) {
        newToggle.addEventListener('click', function() {
          const isActive = newPopup.classList.contains('active');
          if (isActive) {
            newPopup.classList.remove('active');
            newToggle.classList.remove('active');
          } else {
            newPopup.classList.add('active');
            newToggle.classList.add('active');
          }
        });
      }
    } else {
      footer.style.display = 'block';
      const subtotal = footer.querySelector('#miniCartSubtotal');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }

    let itemsHTML = '';
    cart.items.forEach((item, index) => {
      const lineNumber = index + 1;
      const imageSrc = item.image ? item.image.replace(/\.jpg|\.png|\.gif|\.jpeg/gi, '_120x$&') : '';
      const variantTitle = item.variant_title !== 'Default Title' ? `<p class="mini-cart__item-variant">${item.variant_title}</p>` : '';

      itemsHTML += `
        <div class="mini-cart__item" data-line="${lineNumber}" data-key="${item.key}">
          <div class="mini-cart__item-image">
            ${imageSrc ? `<img src="${imageSrc}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<div class="mini-cart__item-image-placeholder"></div>'}
          </div>
          <div class="mini-cart__item-details">
            <h3 class="mini-cart__item-title">${escapeHtml(item.product_title)}</h3>
            ${variantTitle}
            <div class="mini-cart__item-price">${formatMoney(item.final_line_price)}</div>
            <div class="mini-cart__item-quantity">
              <button class="mini-cart__quantity-btn" data-action="decrease" data-line="${lineNumber}" aria-label="Diminuir quantidade">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                </svg>
              </button>
              <input type="number" class="mini-cart__quantity-input" value="${item.quantity}" min="1" data-line="${lineNumber}" readonly>
              <button class="mini-cart__quantity-btn" data-action="increase" data-line="${lineNumber}" aria-label="Aumentar quantidade">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                </svg>
              </button>
            </div>
          </div>
          <button class="mini-cart__item-remove" data-line="${lineNumber}" aria-label="Remover item">
            <svg xmlns="http://www.w3.org/2000/svg" role="presentation" class="icon icon-remove" viewBox="0 0 24 24" fill="none">
              <path d="M21.0697 5.23C19.4597 5.07 17.8497 4.95 16.2297 4.86V4.85L16.0097 3.55C15.8597 2.63 15.6397 1.25 13.2997 1.25H10.6797C8.34967 1.25 8.12967 2.57 7.96967 3.54L7.75967 4.82C6.82967 4.88 5.89967 4.94 4.96967 5.03L2.92967 5.23C2.50967 5.27 2.20967 5.64 2.24967 6.05C2.28967 6.46 2.64967 6.76 3.06967 6.72L5.10967 6.52C10.3497 6 15.6297 6.2 20.9297 6.73C20.9597 6.73 20.9797 6.73 21.0097 6.73C21.3897 6.73 21.7197 6.44 21.7597 6.05C21.7897 5.64 21.4897 5.27 21.0697 5.23Z" fill="currentColor"></path>
              <path d="M19.2297 8.14C18.9897 7.89 18.6597 7.75 18.3197 7.75H5.67975C5.33975 7.75 4.99975 7.89 4.76975 8.14C4.53975 8.39 4.40975 8.73 4.42975 9.08L5.04975 19.34C5.15975 20.86 5.29975 22.76 8.78975 22.76H15.2097C18.6997 22.76 18.8398 20.87 18.9497 19.34L19.5697 9.09C19.5897 8.73 19.4597 8.39 19.2297 8.14ZM13.6597 17.75H10.3297C9.91975 17.75 9.57975 17.41 9.57975 17C9.57975 16.59 9.91975 16.25 10.3297 16.25H13.6597C14.0697 16.25 14.4097 16.59 14.4097 17C14.4097 17.41 14.0697 17.75 13.6597 17.75ZM14.4997 13.75H9.49975C9.08975 13.75 8.74975 13.41 8.74975 13C8.74975 12.59 9.08975 12.25 9.49975 12.25H14.4997C14.9097 12.25 15.2497 12.59 15.2497 13C15.2497 13.41 14.9097 13.75 14.4997 13.75Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
      `;
    });

    miniCartItems.innerHTML = itemsHTML;

    if (miniCartSubtotal) {
      miniCartSubtotal.textContent = formatMoney(cart.total_price);
    }

    reloadProgressBar(cart);
    attachEventListeners();
    if (typeof checkCampaigns === 'function') checkCampaigns();


  }

 function updateQuantity(line, newQuantity) {
    if (isUpdating || newQuantity < 1) return;
    const item = miniCart.querySelector(`[data-line="${line}"]`);
    if (item) item.classList.add('mini-cart__item--loading');
    isUpdating = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQuantity })
    })
    .then(response => response.json())
    // /cart/change.js soma o frete cotado em total_price; /cart.js traz o total real
    .then(() => fetch('/cart.js'))
    .then(response => response.json())
    .then(cart => {
      renderMiniCart(cart);
      updateCartBadge(cart.item_count);
      isUpdating = false;
    })
    .catch(error => {
      console.error('Erro ao atualizar quantidade:', error);
      if (item) item.classList.remove('mini-cart__item--loading');
      isUpdating = false;
    });
  }

  function removeItem(line) {
    if (isUpdating) return;
    const item = miniCart.querySelector(`[data-line="${line}"]`);
    if (item) item.classList.add('mini-cart__item--loading');
    isUpdating = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(response => response.json())
    // /cart/change.js soma o frete cotado em total_price; /cart.js traz o total real
    .then(() => fetch('/cart.js'))
    .then(response => response.json())
    .then(cart => {
      renderMiniCart(cart);
      updateCartBadge(cart.item_count);
      isUpdating = false;
    })
    .catch(error => {
      console.error('Erro ao remover item:', error);
      if (item) item.classList.remove('mini-cart__item--loading');
      isUpdating = false;
    });
  }


  function updateCartBadge(count) {
    const badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function reloadProgressBar(cart) {
    const progressBarContainer = miniCart.querySelector('.mini-cart__progress-bar');
    if (!progressBarContainer) return;
    updateProgressBarManually(cart, progressBarContainer);
  }

  function updateProgressBarManually(cart, container) {
    const progressBar = container.querySelector('.cart-progressbar');
    const progressDiv = container.querySelector('.progress');
    const progressDot = container.querySelector('.progress-dot');

    if (!progressBar || !progressDiv) return;

    const currentValue = cart.total_price / 100;

    // Ler todos os steps do DOM
    const stepEls = Array.from(progressBar.querySelectorAll('.progress-step'));
    const steps = stepEls.map(el => ({
      el,
      value: parseFloat(el.dataset.step),
      text: el.dataset.text || '',
      position: parseFloat(el.style.getPropertyValue('--position') || '100')
    })).filter(s => !isNaN(s.value));

    if (steps.length === 0) return;

    // Determinar progresso visual
    let visualProgress = 0;
    let nextStep = null;
    let prevStepPosition = 0;
    let prevStepValue = 0;

    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      if (currentValue < step.value) {
        nextStep = step;
        const range = step.value - prevStepValue;
        const posRange = step.position - prevStepPosition;
        const progress = (currentValue - prevStepValue) / range;
        visualProgress = prevStepPosition + (progress * posRange);
        break;
      }
      prevStepPosition = step.position;
      prevStepValue = step.value;
    }

    // Se passou de todos os steps
    if (nextStep === null) {
      visualProgress = steps[steps.length - 1].position;
    }

    // Atualizar barra
    progressBar.dataset.currentValue = currentValue;
    progressBar.style.setProperty('--progress-width', visualProgress + '%');
    progressDiv.style.width = visualProgress + '%';
    if (progressDot) progressDot.style.left = visualProgress + '%';

    // Atualizar classes dos steps
    steps.forEach(step => {
      if (currentValue >= step.value) {
        step.el.classList.add('progress-step-active');
      } else {
        step.el.classList.remove('progress-step-active');
      }
    });

    // Textos
    const promotionalText = container.querySelector('.promotional-text');
    const congratulationsText = container.querySelector('.congratulations-text');

    if (nextStep) {
      // Ainda há próximo prêmio
      const remaining = nextStep.value - currentValue;
      const formattedRemaining = formatMoney(remaining * 100);

      if (promotionalText) {
        promotionalText.style.display = 'block';
        const instigator = promotionalText.querySelector('.instigator');
        const promotion = promotionalText.querySelector('.promotion');
        if (instigator) instigator.textContent = 'Adicione mais ' + formattedRemaining + ' para ganhar';
        if (promotion) promotion.textContent = nextStep.text;
      }
      if (congratulationsText) congratulationsText.style.display = 'none';
} else {
      // Todos os steps conquistados
      if (promotionalText) {
        promotionalText.style.display = 'block';
        const instigator = promotionalText.querySelector('.instigator');
        const promotion = promotionalText.querySelector('.promotion');
        const rewards = steps.map(s => s.text).join(' e ');
        if (instigator) instigator.textContent = 'Parabéns! Você ganhou';
        if (promotion) {
          promotion.style.fontWeight = 'bold';
          promotion.textContent = rewards;
        }
      }
      if (congratulationsText) congratulationsText.style.display = 'none';
    }

  }

  function attachEventListeners() {
    const quantityBtns = miniCart.querySelectorAll('.mini-cart__quantity-btn');
    quantityBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const action = this.dataset.action;
        const line = parseInt(this.dataset.line);
        const input = miniCart.querySelector(`.mini-cart__quantity-input[data-line="${line}"]`);
        if (!input) return;
        const currentQty = parseInt(input.value);
        const newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
        updateQuantity(line, newQty);
      });
    });
    const removeBtns = miniCart.querySelectorAll('.mini-cart__item-remove');
    removeBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const line = parseInt(this.dataset.line);
        removeItem(line);
      });
    });
  }

  if (miniCartShippingToggle && miniCartShippingPopup) {
    miniCartShippingToggle.addEventListener('click', function() {
      const isActive = miniCartShippingPopup.classList.contains('active');
      if (isActive) {
        miniCartShippingPopup.classList.remove('active');
        miniCartShippingToggle.classList.remove('active');
      } else {
        miniCartShippingPopup.classList.add('active');
        miniCartShippingToggle.classList.add('active');
      }
    });
    document.addEventListener('click', function(e) {
      if (!miniCartShippingToggle.contains(e.target) && !miniCartShippingPopup.contains(e.target)) {
        miniCartShippingPopup.classList.remove('active');
        miniCartShippingToggle.classList.remove('active');
      }
    });
  }

  if (miniCartClose) miniCartClose.addEventListener('click', closeMiniCart);
  if (miniCartOverlay) miniCartOverlay.addEventListener('click', closeMiniCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && miniCart.classList.contains('active')) closeMiniCart();
  });

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.getAttribute('action') === '/cart/add' || form.action.includes('/cart/add')) {
      const behavior = form.dataset.addToCartBehavior;
      if (behavior === 'redirect') return;
      e.preventDefault();
      const formData = new FormData(form);
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton ? submitButton.textContent : '';
      if (submitButton) { submitButton.disabled = true; submitButton.textContent = 'Adicionando...'; }
      fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(response => response.json())
      .then(data => {
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = originalText; }
        if (window.theme && window.theme.showToast) window.theme.showToast('✓ Produto adicionado ao carrinho!', 'success', 2000);
        if (!window.__calculandoFrete) openMiniCart();
        window.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: data } }));
      })
      .catch(error => {
        console.error('Erro ao adicionar ao carrinho:', error);
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = originalText; }
        alert('Erro ao adicionar produto ao carrinho. Tente novamente.');
      });
    }
  });

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return 'R$ ' + value.replace('.', ',');
  }

  function escapeHtml(text) {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

 window.theme = window.theme || {};
  window.theme.openMiniCart = openMiniCart;
  window.theme.closeMiniCart = closeMiniCart;
  window.theme.reloadMiniCart = reloadMiniCart;
  window.theme.updateCartBadge = updateCartBadge;
  window.reloadMiniCart = reloadMiniCart; // ← adicionar aqui

  updateCartBadge(parseInt(miniCart.dataset.itemCount || 0));

})();